import { ORDER_TYPE } from '../../components/Creators/constants/sortOptions';

/**
 * Normalizes cursor-based pagination parameters based on sort order.
 * This is used for link-based pagination (not offset-based), where the next page
 * is provided via a link in the response header (x-link-next).
 *
 * For ascending order: sets direction to 'up' and initial timestamp cursor.
 * For descending order: sets direction to 'down'.
 *
 * @param {Object} params - Query parameters
 * @param {string} [params.order] - Sort order ('asc' or 'desc')
 * @returns {Object} Normalized parameters with cursor pagination settings
 */
export const normalizeCursorPaginationParams = params => {
  if (!params || typeof params !== 'object') {
    return params;
  }

  const { order, ...restParams } = params;
  const isDescending = !(order === ORDER_TYPE.ASC);

  const normalizedParams = {
    ...restParams,
    order: isDescending ? ORDER_TYPE.DESC : ORDER_TYPE.ASC,
  };

  if (isDescending) {
    normalizedParams.direction = 'down';
  } else {
    normalizedParams.direction = 'up';
    normalizedParams.at = new Date('1970-01-01').toISOString();
  }

  return normalizedParams;
};
